import instanceAPI from 'services/apis/axiosconfig';
import { NEWSLETTER_SUBMIT_URL } from 'constants/Constants';

const axiosConfig = {
  withCredentials: true,
};

export const postNewsletter = (data) => {
  const request = instanceAPI.post(NEWSLETTER_SUBMIT_URL, data, axiosConfig);
  return request.then((res) => res).catch((error) => error);
};
